import React, { useState } from "react";
import { MissInfoReport } from "../../components/MissInfo";
import { Stack } from "react-bootstrap";
import styled from "styled-components";
import { useAuth } from "../../Context/AuthContext";
import { httpClient } from "../../utils/HttpClient";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import SimpleDateFilters from "./_SimpleDateFilters";
import ExternalCampaignsList from "./_ExternalCampaignsList";
const Divider = styled.div`
  background: #dfdfdf;
  width: 100%;
  height: 1px;
  margin-top: 20px;
  margin-bottom: 20px;
`;
const ReportExternalCampaings = () => {
  const Auth = useAuth();
  const [reportData, setReportData] = useState(null);
  const [periodStr, setPeriodStr] = useState("");
  const [loading, setLoading] = useState(false);
  var userData = Auth.getSessionData();

  const getDataReport = (filters) => {
    setReportData(null);
    setLoading(true);
    const URI = ApiEndpoint + "administration/report/externalcampaigns";

    httpClient(
      "POST",
      URI,
      {
        from: filters.dateFrom,
        to: filters.dateTo,
      },
      userData.token
    )
      .then(function (response) {
        setReportData(response.data);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <>
      <div className="">
        <Stack direction="horizontal" gap={2}>
          <div>
            <h2>Resumen por fecha</h2>
            <h3>Resumen de Mensajes exitosos con base en la fecha.</h3>
          </div>
        </Stack>

        <div className="ReportDate">
          <SimpleDateFilters
            onRefresh={getDataReport}
            setPeriodStr={setPeriodStr}
            loading={loading}
          />
        </div>

        <Divider />
        {reportData ? (
          <ExternalCampaignsList
            periodStr={periodStr}
            listCampaigns={reportData}
          ></ExternalCampaignsList>
        ) : (
          <MissInfoReport />
        )}
      </div>
    </>
  );
};

export default ReportExternalCampaings;
